import React, { useEffect } from 'react';
import { Select } from 'antd';
import { useModalWatch } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import { useAddressOwnersQuery } from '../../../../api/addressOwners';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import { useFieldController } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../constants';
import Field from '../../../../shared/ui/Field';

const emptyArr = [];
const SelectOwner = () => {
  const addressId = useModalWatch({
    name: modalNames.attachmentsForm,
    selector: (state) => state?.props?.room?.id,
  });

  const { data, isFetching, refetch } = useAddressOwnersQuery({
    params: { addressId },
  });

  const controller = useFieldController({
    name: fieldNames.clientId,
    rules: { required: 'Выберите собственника' },
  });

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Не удалось получить список собственников для данного адреса"
      ignoreEmpty
    >
      <SelectOwnerBase
        clients={Array.isArray(data) ? data : emptyArr}
        controller={controller}
      />
    </FetchDataWrapper>
  );
};

export default SelectOwner;

function SelectOwnerBase({ clients, controller }) {
  const {
    field: { value, onChange },
    fieldState,
  } = controller;

  const handleChange = (value) => {
    onChange(value);
  };

  useEffect(() => {
    if (clients?.length === 1 && !value) {
      onChange(clients[0].id);
    }
  }, [clients, value, onChange]);

  return (
    <Field.Memoized
      type={Field.types.select}
      value={clients.length ? value : undefined}
      onChange={handleChange}
      formItemLabel="Собственник"
      required
      style={{ width: '100%' }}
      optionFilterProp="search"
      showSearch={clients?.length > 10}
      errorMessage={fieldState.error?.message}
    >
      {clients?.map((client) => (
        <Select.Option key={client.id} value={client.id} search={client.name}>
          {client.name}
        </Select.Option>
      ))}
    </Field.Memoized>
  );
}
